import * as R from 'ramda';

import { ReduxAsyncAction } from '../support/utils';
import dash_api from '../support/dash_api';

/**
 * Fetch list of ad links
 * @param  {Object} payload
 * @return {Object} action
 */
const GetAdLinks = new ReduxAsyncAction('AD_LINKS_GET_AD_LINKS');
GetAdLinks.registerRequest(function () {
  return dash_api.get(`/v1/link-creator/ads`).then(R.prop('data'));
});

export const GET_AD_LINKS = GetAdLinks.constants;
export const getAdLinks = GetAdLinks.request;

export const UPDATE_AD_LINKS = 'AD_LINKS_UPDATE_AD_LINKS';
export function updateAdLinks(link) {
  return {
    type: UPDATE_AD_LINKS,
    data: link,
  };
}

/**
 * Archive/Unarchive Ads link
 * @param {Object}  payload
 * @param {string}  payload.link_id
 * @param {boolean} payload.archive
 * @return {Object} action
 */
const ArchiveAdsLink = new ReduxAsyncAction('LINK_CREATOR_ARCHIVE_LINK');
ArchiveAdsLink.registerRequest(function (payload) {
  return dash_api.put(`/v1/link-creator/ads/${payload.link_id}/${payload.archived}`, payload).then(({ data }) => {
    data.link_id = payload.link_id;

    return data;
  });
});

ArchiveAdsLink.showProgressBar();
export const ARCHIVE_LINK = ArchiveAdsLink.constants;
export const archiveAdsLink = ArchiveAdsLink.request;
